var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B7F4",
    fillRule: "evenodd",
    d: "M2.46 2.46a8.4 8.4 0 0 1 11.88 11.88L8.4 20.28l-5.94-5.94a8.4 8.4 0 0 1 0-11.88M8.4 10.8a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
    clipRule: "evenodd"
  })));
};
export default SvgLocation;